export enum LandingPage {
  DASHBOARD = 1,
  ACTIVATE_WARRANTY = 2,
  PROFILE = 3,
  WARRANTY_LIST = 4
}
